var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02017 18.1299V14.8799C6.02017 14.6599 6.37017 14.3199 6.58017 14.2499C7.23017 14.0299 7.72017 14.4899 7.78017 15.1299C7.90017 16.6899 7.68017 18.4098 7.78017 19.9798C7.74017 20.4498 7.51017 20.8198 7.02017 20.9098L1.69017 20.8899C0.720174 20.6799 0.930174 19.1499 1.85017 19.1499H4.54017C3.03017 17.3599 2.07017 15.0798 1.87017 12.7398C1.07017 3.17985 11.7802 -3.08016 19.7302 2.35984C27.0602 7.37984 26.0102 18.6398 17.8802 22.2198C16.6302 22.7698 14.5202 23.3199 13.1602 23.1999C12.1602 23.1099 12.0902 21.5699 13.1602 21.4499C13.5802 21.3999 14.0502 21.4299 14.4902 21.3699C23.2702 20.2399 26.0002 8.75988 18.6702 3.76988C11.3002 -1.24012 1.63017 5.65989 3.91017 14.2799C4.28017 15.6799 5.02017 17.0799 6.01017 18.1399L6.02017 18.1299Z",
    fill: "#A797BA",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0106 16.6699C16.7006 16.9799 16.2306 17 15.8706 16.77L12.5806 13.4899C12.4706 13.3399 12.4006 13.1699 12.3906 12.9799V6.75995C12.5506 5.72995 13.9506 5.70992 14.1406 6.72992L14.1606 12.58L17.1206 15.5599C17.3406 15.8899 17.3006 16.3899 17.0206 16.6699H17.0106Z",
    fill: "#A797BA",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentTime);
export default __webpack_public_path__ + "static/media/recent-time.727a5701dec44c7778d6af1551fe1bb9.svg";
export { ForwardRef as ReactComponent };